export default __webpack_public_path__ + "../staticImages/trauben_gruen-260.png";